import React from 'react';
import Container from 'common/components/UI/Container';
import ScreenImage from '../../Custom/ScreenImage';
import {
  Wrapper,
  Intro,
  TopicGrid,
  Topic,
  Notes,
  Shots,
} from './savingsworkspace.style';

const TOPICS = [
  {
    title: 'Overview',
    text:
      'What the scan is worth, at a glance: monthly cost with the potential savings percentage in green, the top finding, and a savings flow diagram that follows the money from Service to Finding to Solution. A short summary of what was analyzed comes with it, including anything CloudPouch could not check.',
  },
  {
    title: 'Opportunities',
    text:
      'Every individual finding in one table you can search, filter and sort: the service, the resource, the recommended solution and the estimated monthly saving. Open a finding to see why CloudPouch flagged it, with the metrics, configuration or reference data behind it and the recommended action. Pro.',
  },
  {
    title: 'History',
    text:
      'CloudPouch saves scan runs locally, per profile. Closing the app immediately after a scan finishes can leave that run unsaved. Reopen a saved run, delete it, or export it on Pro. When a newer run exists for the same profile, a banner offers to jump straight to it.',
  },
  {
    title: 'Honest about coverage',
    text:
      'A missing permission is never reported as "nothing to optimize". The Coverage and Permission issues panels name the service, the region, the API operation and the AWS error code involved.',
  },
];

const SHOT_SIZES =
  '(min-width: 1220px) 1110px, (min-width: 992px) 910px, (min-width: 768px) 690px, calc(100vw - 60px)';

const SHOTS = [
  {
    name: 'cloudpouch-2-savings-overview-sankey',
    alt:
      'CloudPouch Savings Overview for the ACME-prod profile, current month: summary cards with estimated monthly savings, and a savings flow diagram from finding to resource type to solution.',
    caption: 'Savings Overview with the savings flow diagram.',
  },
  {
    name: 'cloudpouch-2-opportunities-evidence',
    alt:
      'CloudPouch Opportunities table with one opportunity expanded, showing the recommended action to migrate an EBS volume to SC1, its cost basis and current configuration.',
    caption: 'Opportunity details with evidence and the recommended action.',
  },
];

const SavingsWorkspaceSection = () => (
  <Wrapper id="savings_workspace">
    <Container>
      <Intro>
        <span>SAVINGS WORKSPACE</span>
        <h2>Run one scan. See where your AWS money goes to waste.</h2>
        <p>
          A Savings Scan analyzes the AWS services CloudPouch supports that have
          costs in one profile and one month, in a single pass. The results land in the
          Savings Workspace, a view of its own next to Billing.
        </p>
      </Intro>

      <TopicGrid>
        {TOPICS.map((topic) => (
          <Topic key={topic.title}>
            <h3>{topic.title}</h3>
            <p>{topic.text}</p>
          </Topic>
        ))}
      </TopicGrid>

      <Notes>
        <p>
          Savings analysis covers the current month and the previous month.
          Figures are estimates, not guarantees. Press ⌘S to open the
          workspace, or Ctrl+S on Windows and Linux.
        </p>
        <p>
          The free plan is our basic plan and includes the full scan, the
          Overview and the savings flow. Pro, which is every paid plan, adds
          the Opportunities list with evidence, full history and export.
        </p>
        <a href="#plans">See Free vs Pro</a>
      </Notes>

      <Shots>
        {SHOTS.map((shot) => (
          <figure key={shot.name}>
            <ScreenImage
              name={shot.name}
              alt={shot.alt}
              sizes={SHOT_SIZES}
              width={1600}
              height={1098}
            />
            <figcaption>{shot.caption}</figcaption>
          </figure>
        ))}
      </Shots>
    </Container>
  </Wrapper>
);

export default SavingsWorkspaceSection;
